<template>
<section id="breadcrumbs" class="hero section">
    <div class="container has-text-centered">
        <h1 v-if="is_h1" class="title is-2">{{site_data.title}}</h1>
        <p v-else class="title">{{site_data.title}}</p>
        <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
                <li><router-link :to="{ name: 'Homepage' }">Home</router-link></li>
                <li v-for="navitem in site_data.ancestors"><router-link :to="navitem.link">{{navitem.title}}</router-link></li>
            </ul>
        </nav>
    </div>
</section>
</template>

<script>
export default {
    name    :   'Breadcrumb',
    props   :   {
        is_h1       :   {
            type    :   Boolean,
            default :   true
        }
    },
    computed    :   {
        site_data()
        {
            return this.$store.state.site_data;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/Breadcrumb.vue